
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../../http/http';
import { success, error } from '../../../../../services/alert-message';

const urlApi = 'distribuicao/api/acesso-restrito';

/**
* Lista cartórios com pedidos pendentes
* @param {*} param0
*/
export async function cartoriosPedidosPendentesList({ state, commit }, obj) {
  Loading.show();

  return (await http.get(`${urlApi}/lista-cartorio-pedido-pendente?${obj.filtros}`)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}

/**
* Pedidos do cartório
* @param {*} param0
*/
export async function pedidosPendentesList({ state, commit }, obj) {
  Loading.show();

  return (await http.get(`${urlApi}/cartorios/${obj.cartorioId}/pedidos-pendentes?${obj.filtros}`)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
